import React from 'react';

import { makeStyles } from '@material-ui/core';

import Search from './search/Search';

const useStyles = makeStyles((theme) => style(theme));

function OwnershipSearch () {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Search />
        </div>
    ); 
}

const style = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    }
});

export default OwnershipSearch;